import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const PanierContexte = createContext(null);

function chargerLocal() {
  const raw = localStorage.getItem('shopmarega_panier');
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

function sauvegarderLocal(items) {
  localStorage.setItem('shopmarega_panier', JSON.stringify(items));
}

export function PanierProvider({ children }) {
  const [items, setItems] = useState(() => chargerLocal());

  useEffect(() => {
    sauvegarderLocal(items);
  }, [items]);

  const total = useMemo(() => {
    return items.reduce((sum, it) => sum + Number(it.prix_unitaire || 0) * Number(it.quantite || 0), 0);
  }, [items]);

  function ajouter({ produit_id, variante_id, nom, variante_libelle, prix_unitaire, image_url, quantite = 1 }) {
    setItems((prev) => {
      const idx = prev.findIndex(
        (x) => Number(x.produit_id) === Number(produit_id) && Number(x.variante_id || 0) === Number(variante_id || 0)
      );
      if (idx >= 0) {
        const cp = [...prev];
        cp[idx] = { ...cp[idx], quantite: Number(cp[idx].quantite) + Number(quantite) };
        return cp;
      }
      return [
        ...prev,
        {
          produit_id: Number(produit_id),
          variante_id: variante_id ? Number(variante_id) : null,
          nom,
          variante_libelle: variante_libelle || null,
          prix_unitaire: Number(prix_unitaire || 0),
          image_url: image_url || null,
          quantite: Number(quantite)
        }
      ];
    });
  }

  function changerQuantite({ produit_id, variante_id, quantite }) {
    setItems((prev) =>
      prev
        .map((x) => {
          if (Number(x.produit_id) !== Number(produit_id)) return x;
          if (Number(x.variante_id || 0) !== Number(variante_id || 0)) return x;
          return { ...x, quantite: Number(quantite) };
        })
        .filter((x) => Number(x.quantite) > 0)
    );
  }

  function supprimer({ produit_id, variante_id }) {
    setItems((prev) =>
      prev.filter(
        (x) => !(Number(x.produit_id) === Number(produit_id) && Number(x.variante_id || 0) === Number(variante_id || 0))
      )
    );
  }

  function vider() {
    setItems([]);
  }

  const value = useMemo(
    () => ({ items, total, ajouter, changerQuantite, supprimer, vider, nbArticles: items.reduce((s, x) => s + x.quantite, 0) }),
    [items, total]
  );

  return <PanierContexte.Provider value={value}>{children}</PanierContexte.Provider>;
}

export function usePanier() {
  const ctx = useContext(PanierContexte);
  if (!ctx) {
    throw new Error('usePanier doit être utilisé dans PanierProvider');
  }
  return ctx;
}
